export const getRandom = () => {
  return Math.random() - 0.5;
};
